import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { DeviceInformationStoreActions, DeviceInformationStoreStates } from '../device-information-store';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../router';

@Injectable()
export class DeviceInformationResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly deviceInformationStore: Store<DeviceInformationStoreStates.DeviceInformationState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.deviceInformationStore.dispatch(
          DeviceInformationStoreActions.DeviceInformationResolverActions.deviceRequested({
            udid,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
